import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { FaWrench, FaLaptopMedical, FaCog, FaBatteryFull } from 'react-icons/fa';

const Services = () => {
  const { t } = useLanguage();

  const serviceCategories = [
    {
      title: t('services.europeanRepair'),
      icon: <FaWrench size={48} />,
      image: 'https://customer-assets.emergentagent.com/job_premium-workshop-1/artifacts/v0rye9tu_Workshop2.jpeg',
      services: [
        t('services.engineRepair'),
        t('services.transmissionRepair'),
        t('services.coolingSystem'),
        t('services.suspension'),
        t('services.brakeSystem')
      ]
    },
    {
      title: t('services.diagnostics'),
      icon: <FaLaptopMedical size={48} />,
      image: 'https://customer-assets.emergentagent.com/job_premium-workshop-1/artifacts/44zt2kut_Workshop5.jpeg',
      services: [
        t('services.engineDiag'),
        t('services.electricalDiag'),
        t('services.ecuDiag'),
        t('services.warningLight'),
        t('services.coding')
      ]
    },
    {
      title: t('services.maintenance'),
      icon: <FaCog size={48} />,
      image: 'https://customer-assets.emergentagent.com/job_premium-workshop-1/artifacts/dfgwra1l_Workshop18.jpeg',
      services: [
        t('services.oilService'),
        t('services.majorService'),
        t('services.acService'),
        t('services.brakeFluid'),
        t('services.transService')
      ]
    },
    {
      title: t('services.hybrid'),
      icon: <FaBatteryFull size={48} />,
      image: 'https://customer-assets.emergentagent.com/job_premium-workshop-1/artifacts/8uizlpnp_New%202.jpeg',
      services: [
        t('services.batteryDiag'),
        t('services.batteryRepair'),
        t('services.batteryReplace'),
        t('services.systemInspection'),
        t('services.hvTesting')
      ]
    }
  ];

  return (
    <div className="min-h-screen" data-testid="services-page">
      {/* Hero Section */}
      <section className="relative h-[400px] flex items-center bg-cover bg-center"
        style={{ backgroundImage: 'url(https://customer-assets.emergentagent.com/job_premium-workshop-1/artifacts/v0rye9tu_Workshop2.jpeg)' }}
      >
        <div className="absolute inset-0 bg-dark-navy/80"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full text-center">
          <h1 className="font-cabinet font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white mb-4">
            {t('services.title')}
          </h1>
          <p className="text-lg text-gray-200">{t('services.heading')}</p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {serviceCategories.map((category, index) => (
              <div key={index} data-testid={`service-category-${index}`} className="border border-gray-200 hover:shadow-lg transition-shadow">
                <div className="relative h-64 overflow-hidden">
                  <img src={category.image} alt={category.title} className="w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-t from-dark-navy/90 to-transparent"></div>
                  <div className="absolute bottom-6 left-6">
                    <div className="text-royal-blue mb-3">
                      {category.icon}
                    </div>
                    <h2 className="font-cabinet font-bold text-2xl text-white">
                      {category.title}
                    </h2>
                  </div>
                </div>
                <div className="p-8 bg-light-grey">
                  <ul className="space-y-3">
                    {category.services.map((service, idx) => (
                      <li key={idx} className="flex items-center space-x-3">
                        <div className="w-2 h-2 bg-royal-blue rounded-full flex-shrink-0"></div>
                        <span className="text-gray-700 text-base">{service}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-royal-blue text-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="font-cabinet font-bold text-2xl sm:text-3xl mb-4">
            Need Professional Service?
          </h2>
          <p className="text-base mb-8 text-gray-200">
            Contact us today for a consultation
          </p>
          <a 
            href="/contact"
            data-testid="service-cta-contact"
            className="inline-block px-8 py-3 bg-white text-royal-blue font-cabinet font-bold hover:bg-gray-100 transition-colors"
          >
            {t('nav.contact')}
          </a>
        </div>
      </section>
    </div>
  );
};

export default Services;